export const View = {
  Edit: (id) => `view:edit:${id}`
};
